import { render, staticRenderFns } from "./Geofence.vue?vue&type=template&id=851dfa12&"
import script from "./Geofence.vue?vue&type=script&lang=js&"
export * from "./Geofence.vue?vue&type=script&lang=js&"
import style0 from "./Geofence.vue?vue&type=style&index=0&id=851dfa12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports